:host {
  padding: var(--wb-spacing-s) 0;
  display: none;
}

:host([selected]) {
  display: block;
}
